import { Component, OnInit } from '@angular/core';

import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { MarketingViewModel } from '@frontend/sports/types/components/marketing';
import { Observable } from 'rxjs';

import { QuickLinkItem } from '../../../../quick-links/quick-links.models';
import { GreyhoundService } from '../../../common/greyhound-service';

@Component({
    selector: 'ms-greyhounds-base',
    templateUrl: 'greyhounds-base.component.html',
    standalone: false,
})
export class GreyHoundsBaseComponent implements OnInit {
    sport: string = SportConstant.Greyhounds.toString();
    quickLink$: Observable<{ quickLinkItem: QuickLinkItem[]; layout: string }>;

    promoBanners$: Observable<MarketingViewModel[]>;

    constructor(private greyhoundService: GreyhoundService) {}

    ngOnInit(): void {
        this.quickLink$ = this.greyhoundService.getQuickLinks$;
        this.promoBanners$ = this.greyhoundService.getPromo$;
    }
}
